import { RegistrationForm } from '@/components/organisms';
import { Icon } from '@/components/atoms';

export default function RegistrationPage() {
  return (
    <div className="min-h-screen flex">
      {/* Left Panel - Branding */}
      <div className="hidden lg:flex lg:w-1/2 bg-gradient-to-br from-success-600 via-success-700 to-success-800 p-12 flex-col justify-between relative overflow-hidden">
        {/* Background Pattern */}
        <div className="absolute inset-0 opacity-10">
          <svg className="w-full h-full" xmlns="http://www.w3.org/2000/svg">
            <pattern id="grid" width="40" height="40" patternUnits="userSpaceOnUse">
              <circle cx="20" cy="20" r="1.5" fill="white" />
            </pattern>
            <rect width="100%" height="100%" fill="url(#grid)" />
          </svg>
        </div>

        <div className="relative z-10">
          <div className="flex items-center gap-3 mb-8">
            <div className="bg-white bg-opacity-20 p-3 rounded-xl backdrop-blur-sm">
              <Icon name="Sprout" size={32} className="text-white" />
            </div>
            <div>
              <h1 className="text-2xl font-bold text-white">FPO ERP System</h1>
              <p className="text-success-100 text-sm">Agricultural Management Platform</p>
            </div>
          </div>
        </div>

        <div className="relative z-10 space-y-8">
          <div>
            <h2 className="text-4xl font-bold text-white mb-4">
              Join Our Growing<br />Community
            </h2>
            <p className="text-success-100 text-lg leading-relaxed">
              Start managing your FPO operations efficiently. Get access to inventory management,
              sales tracking, member management, and comprehensive reporting tools.
            </p>
          </div>

          <div className="space-y-4">
            <div className="flex items-start gap-3">
              <div className="bg-white bg-opacity-20 p-2 rounded-lg">
                <Icon name={"CheckCircle" as any} size={20} className="text-white" />
              </div>
              <div>
                <p className="text-white font-semibold">Complete Inventory Management</p>
                <p className="text-success-100 text-sm">Track inputs, outputs, and stock levels in real-time</p>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <div className="bg-white bg-opacity-20 p-2 rounded-lg">
                <Icon name={"CheckCircle" as any} size={20} className="text-white" />
              </div>
              <div>
                <p className="text-white font-semibold">Sales & Revenue Tracking</p>
                <p className="text-success-100 text-sm">Monitor transactions and financial performance</p>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <div className="bg-white bg-opacity-20 p-2 rounded-lg">
                <Icon name={"CheckCircle" as any} size={20} className="text-white" />
              </div>
              <div>
                <p className="text-white font-semibold">Member Management</p>
                <p className="text-success-100 text-sm">Manage farmer profiles and track their contributions</p>
              </div>
            </div>
          </div>
        </div>

        <div className="relative z-10">
          <p className="text-success-200 text-sm">
            Designed specifically for Indian Farmer Producer Organizations
          </p>
        </div>
      </div>

      {/* Right Panel - Registration Form */}
      <div className="flex-1 flex items-center justify-center p-8 bg-neutral-50">
        <div className="w-full max-w-md">
          {/* Mobile Logo */}
          <div className="lg:hidden flex items-center gap-3 mb-8">
            <div className="bg-success-100 p-3 rounded-xl">
              <Icon name="Sprout" size={28} className="text-success-600" />
            </div>
            <div>
              <h1 className="text-xl font-bold text-neutral-900">FPO ERP System</h1>
              <p className="text-neutral-600 text-sm">Agricultural Management</p>
            </div>
          </div>

          <div className="bg-white rounded-2xl shadow-xl border border-neutral-200 p-8">
            <div className="mb-8">
              <h2 className="text-2xl font-bold text-neutral-900">Create your account</h2>
              <p className="mt-2 text-neutral-600">Get started with FPO ERP in minutes</p>
            </div>

            <RegistrationForm />

            <div className="mt-6 pt-6 border-t border-neutral-200">
              <p className="text-center text-sm text-neutral-600">
                Already have an account?{' '}
                <a
                  href="/login"
                  className="font-semibold text-success-600 hover:text-success-700 transition-colors"
                >
                  Sign in
                </a>
              </p>
            </div>
          </div>

          <div className="mt-8 text-center">
            <p className="text-xs text-neutral-500">
              By creating an account, you agree to our{' '}
              <a href="#" className="text-success-600 hover:underline">Terms of Service</a>
              {' '}and{' '}
              <a href="#" className="text-success-600 hover:underline">Privacy Policy</a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
